// @ts-nocheck
import { useCallback, useState } from "react";

import { css } from "@emotion/css";
import { NumberInput } from "@snapchat/snap-design-system";

import { stopPropagation } from "../../../../common/utils/event";
import { useInputState } from "../../../../core/validation";

// reduce unnesessary right padding from 30 to 16 pixels
// to be able to have a narrower columns
const noInputPaddingCss = css`
    .ant-input-affix-wrapper .ant-input:not(:last-child) {
        padding-right: 16px;
    }
`;

const errorFn = (value: number) => {
    if (value == undefined) {
        return "Missing";
    }
    if (value >= 1000) {
        return "Too high";
    }
    return "Wrong value";
};

interface PriorityCellProps {
    priority: number;
    onChange: (priority: number, isValid: boolean) => void;
    readonly: boolean;
}

export function PriorityCell({ priority, onChange, readonly }: PriorityCellProps) {
    const [state, setState] = useState({ priority, isValid: true });

    const { inputProps } = useInputState<number>({
        error: errorFn,
        defaultValue: priority,
        validator: (newValue) => newValue >= 0 && newValue < 1000,
        onChanged: (priority, isValid) => {
            setState({ priority, isValid });
        },
    });

    const onBlur = useCallback(() => {
        if (state.priority !== priority) {
            onChange(state.priority, state.isValid);
        }
    }, [priority, state.priority, state.isValid, onChange]);

    return (
        <div onClick={stopPropagation}>
            <NumberInput {...inputProps} className={noInputPaddingCss} disabled={readonly} onBlur={onBlur} />
        </div>
    );
}
